import { ResultMoment } from '../services/results.service';
import { UUID } from 'angular2-uuid';
import { EventEmitter } from '@angular/core';
import { SLLayer } from './sl-layer';

export type MomentChange = {
	moment: ResultMoment;
	name: 'change';
}

export class ResultHistory {
	static LATEST_ID = 0;
	static LATEST_TABULAR_ID = 1;
	static PREVIOUS_ID = 2;
	static PREVIOUS_TABULAR_ID = 3;
	private moments: Array<ResultMoment> = [null, null,null,null];
	private newbieCount = 0;
	private defaultSynchSet: any = {
		'results-list': null,
		'popup-control': null,
		info: null
	}
	public synchSet: any;
	public synchSetChange = new EventEmitter<'changing' | 'changed'>();

	public synchResultsSet: any;
	public synchResultsSetChange = new EventEmitter<'changing' | 'changed'>();

	public momentChange = new EventEmitter<MomentChange>();

	protected momentLookup: any = {};
	public momentCount = 0;
	public lastMoment: ResultMoment;


	get entries(): Array<ResultMoment> {
		return this.moments;
	}
	set latest(moment: ResultMoment) {
		const latestMoment = this.latest;
		if (latestMoment) {
			latestMoment.name = 'Previous Spatial Search Result Set'
			this.previous = latestMoment;
		}
		this.UpsertMoment(moment, ResultHistory.LATEST_ID);
		this.lastMoment = moment;
	}

	get latest(): ResultMoment | null {
		if (this.moments.hasOwnProperty(ResultHistory.LATEST_ID) === false) {
			return null;
		}
		return this.moments[ResultHistory.LATEST_ID];
	}
	set previous(moment: ResultMoment) {
		this.UpsertMoment(moment, ResultHistory.PREVIOUS_ID);
	}
	set latestTabular(moment: ResultMoment) {
		const latestTabularMoment = this.latestTabular;
		if (latestTabularMoment) {
			this.latestTabular.name = 'Previous Tabular Search Result Set';
			this.previousTabular = latestTabularMoment;
		}

		this.UpsertMoment(moment, ResultHistory.LATEST_TABULAR_ID);
		this.lastMoment = moment;
	}

	get latestTabular(): ResultMoment | null {
		if (this.moments.hasOwnProperty(ResultHistory.LATEST_TABULAR_ID) === false) {
			return null;
		}
		return this.moments[ResultHistory.LATEST_TABULAR_ID];
	}
	set previousTabular(moment: ResultMoment) {
		this.UpsertMoment(moment, ResultHistory.PREVIOUS_TABULAR_ID);
	}
	constructor() {
		this.synchSet = this.defaultSynchSet;
		this.synchResultsSet = this.GetDefaultSynchSet();
	}
	GetMoment(momentId: any): ResultMoment | null {
		if ('' + momentId === '-1') {
			return this.latest;
		}
		if (!!this.momentLookup[momentId]) {
			return this.momentLookup[momentId];
		}
		return null;
	}
	GetDefaultSynchSet(): any {
		return JSON.parse(JSON.stringify(this.defaultSynchSet));
	}
	UpdateMomentsWithLayer(layer: SLLayer) {
		for (const moment of this.moments) {
			if (moment === null) { continue; }
			if (!moment.resultSet) { continue; }
			for (const result of moment.resultSet.results) {
				if (result.layer === layer.id) {
					this.PreUpdateMoment(moment);
					window.requestAnimationFrame(() => {
						this.UpdateMoment(moment);
					});
					break;
				}
			}

		}
	}
	UpdateMoment(moment: ResultMoment, upsert: boolean = false, mergeParams: any = {}) {
		const index = this.moments.indexOf(this.momentLookup[moment.id]);
		if (index > -1) {
			this.UpsertMoment(moment, index);
		} else {
			if (upsert) {
				this.UpsertMoment(moment);
			}
		}
		this.momentCount = this.moments.length;
		const changeEvent: any = { moment: (moment), name: 'moment-change' };
		for (const key in mergeParams) {
			if (mergeParams.hasOwnProperty(key) === true) {
				if (key === 'moment') {
					continue;
				}
				if (key === 'name') {
					continue;
				}
				changeEvent[key] = mergeParams;
			}
		}
		this.momentChange.emit(changeEvent);
	}
	PreUpdateMoment(moment: ResultMoment, mergeParams: any = {}) {
		const changeEvent: any = { moment: (moment), name: 'moment-pre-change' };
		for (const key in mergeParams) {
			if (mergeParams.hasOwnProperty(key) === true) {
				if (key === 'moment') {
					continue;
				}
				if (key === 'name') {
					continue;
				}
				changeEvent[key] = mergeParams;
			}
		}
		this.momentChange.emit(changeEvent);

	}
	UpsertMoment(moment: ResultMoment, index?: number): ResultMoment {
		if ((!!index) || [ResultHistory.LATEST_ID, ResultHistory.LATEST_TABULAR_ID, ResultHistory.PREVIOUS_ID, ResultHistory.PREVIOUS_TABULAR_ID].indexOf(index) > -1) {
			this.moments[index] = moment;
		} else {
			this.moments.push(moment);
			moment.synchs = this.GetDefaultSynchSet();
		}
		this.UpdateLookup();
		this.momentCount = this.moments.length;
		return moment;
	}
	UpsertClone(moment: ResultMoment): ResultMoment {
		const item: any = JSON.parse(JSON.stringify(moment));
		item.id = UUID.UUID();
		this.newbieCount += 1;
		item.name = 'Result Set - ' + this.newbieCount;
		this.UpsertMoment(item as ResultMoment);
		return item as ResultMoment;
	}
	RemoveMoment(id: number) {
		this.moments = this.moments.splice(id, 1);
		this.momentCount = this.moments.length;
	}
	RemoveAMoment(moment: ResultMoment) {
		const id: number = this.moments.indexOf(moment);
		this.RemoveMoment(id);
	}

	UpdateLookup() {
		this.momentLookup = {};
		for (const moment of this.moments) {
			if (!!moment) {
				this.momentLookup[moment.id] = moment;
			}
		}
	}
	RegisterSynch(synchId: string, momentId: string) {
		this.synchSet[synchId] = momentId;
		window.requestAnimationFrame(() => {
			this.UpdateMomentSyncs();
		});
	}
	RegisterSelection(synchId: string, selectionId: string) {
		this.synchResultsSet[synchId] = selectionId;
		this.synchResultsSetChange.emit(this.synchResultsSet);
	}
	UpdateMomentSyncs() {
		this.synchSetChange.emit('changing');
		for (const moment of this.moments) {
			if (!!moment) {
				for (const synchId in this.synchSet) {
					if (this.synchSet.hasOwnProperty(synchId)) {
						moment.synchs[synchId] = (moment.id === this.synchSet[synchId]);
					}
				}
			}
		}
		this.synchSetChange.emit('changed');
	}
}